import { c as _c } from "react/compiler-runtime";
import { NotificationTypeEnum } from 'modules/profile/notification-settings/enums/notification-settings-enum';
import { NotificationsApiInterface } from 'modules/notifications/types/notification-types';
import { useWaitedStudentProgressExportIdsStorage } from './use-waited-student-progress-export-ids-storage';
export const useAwaitedStudentProgressExportNotification = () => {
  const $ = _c(4);
  const {
    getItem,
    setItem,
    removeItem
  } = useWaitedStudentProgressExportIdsStorage();
  let t0;
  if ($[0] !== getItem || $[1] !== removeItem || $[2] !== setItem) {
    const isThereAwaitedStudentProgressExport = notifications => {
      const waitedExportIds = getItem();
      if (!waitedExportIds?.size) {
        return false;
      }
      const gottenExportIds = notifications?.items?.filter(_temp).map(_temp2).filter(_temp3);
      const justGottenExportIds = waitedExportIds.intersection(new Set(gottenExportIds));
      const notGottenExportIds = waitedExportIds.difference(justGottenExportIds);
      if (notGottenExportIds.size) {
        setItem(notGottenExportIds);
        return true;
      }
      removeItem();
      return false;
    };
    t0 = {
      isThereAwaitedStudentProgressExport
    };
    $[0] = getItem;
    $[1] = removeItem;
    $[2] = setItem;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};
function _temp(notification) {
  return notification.eventType === NotificationTypeEnum.StudentProgressExport;
}
function _temp2(notification_0) {
  return notification_0.data.exportId;
}
function _temp3(exportId) {
  return exportId !== null;
}